import Header from './Header'
import Footer from '@astro/footer'
import { MobileBottomNav } from '@astro/layouts'
import FloatingFabs from '@astro/floating-fabs'
import BackToTop from './backToTop/BackToTop'

/**
 * Shared page shell used by every page except the login screen (which is a
 * bespoke full-screen auth layout). Owning the header + footer region here
 * keeps the chrome identical across Home, About, Contact and Horoscope so the
 * pages can never drift apart.
 */
export default function PageLayout({ className = '', children }) {
  return (
    <div className={className}>
      <Header />
      {children}
      <Footer />
      <MobileBottomNav />
      <FloatingFabs />
      <BackToTop />
    </div>
  )
}
